<template>
  <div :class="{ pagination: true, [position]: position }">
    <div class="sorting-wrapper">
      <app-input-select
          class="order-by-select"
          name="order_by"
          ref="order_by"
          v-if="showOrderBy"
          :dropdownDirection="position === 'top' ? 'bottom': 'top'"
          :placeholder="$t('pagination.order_by')"
          :selectedValue="orderBy"
          :options="orderByOptionsArray"
          :allowEmpty="false"
          :onChange="(e) => onPaginationChange('order', e)"
      />
      <div class="sorting-arrows" v-if="showOrderBy">
        <span v-if="sortOrder === 'asc'" class="fad fa-sort-up"
            v-on:click="onPaginationChange('sort', 'desc')"></span>
        <span v-if="sortOrder === 'desc'" class="fad fa-sort-down"
              v-on:click="onPaginationChange('sort', 'asc')"></span>
      </div>
    </div>
    <div class="page-number">
      <span>{{$t('pagination.page_number', [firstItem, lastItem, totalItems])}}</span>
    </div>

    <div class="per-page">
        {{$t('pagination.per_page')}}
        <app-input-select
            class="per-page-select"
            name="items_per_page"
            ref="items_per_page"
            :isLoading="isLoading"
            :disabled="isLoading"
            :selectedValue="itemsPerPage"
            :options="perPageOptions"
            :allowEmpty="false"
            :preselectFirst="true"
            :onChange="(e) => onPaginationChange('perPage', e)"
            dropdownDirection="top"
        />
      </div>

    <div class="paging-arrows">
      <span id="top-first"
            class="fas fa-step-backward"
            :class="{ disabled: currentPage <= 1 || isLoading }"
            v-on:click="onPaginationChange('currentPage', 1)"/>
      <span id="top-previous"
            class="fas fa-caret-left previous"
            :class="{ disabled: currentPage <= 1 || isLoading }"
            v-on:click="onPaginationChange('currentPage', currentPage - 1)"/>
      <span id="top-current-page">{{currentPage}}<span v-if="showTotalPages"> / {{totalPages}}</span></span>
      <span id="top-next"
            class="fas fa-caret-right next"
            :class="{ disabled: currentPage >= totalPages || isLoading }"
            v-on:click="onPaginationChange('currentPage', currentPage + 1)"/>
      <span id="top-last"
            class="fas fa-step-forward"
            :class="{ disabled: currentPage >= totalPages || isLoading }"
            v-on:click="onPaginationChange('currentPage', totalPages)"/>
    </div>
  </div>
</template>

<script>
  import InputSelect from "./form-components/input-select"

  export default {
    props: {
      position: {
        type: String,
        default: 'bottom',
        validator: function (value) {
          return ['bottom', 'top'].indexOf(value) !== -1
        }
      },
      pagination: {
        type: Object,
        required: true
      },
      orderByOptions: {
        type: Array,
        default: () => []
      },
      perPageOptions: {
        type: Array,
        required: false,
        default: () => [
          { label: 5, value: 5 },
          { label: 10, value: 10 },
          { label: 25, value: 25 },
          { label: 50, value: 50 },
          { label: 100, value: 100 }
        ]
      },
      isLoading: {
        type: Boolean,
        default: false
      },
      showTotalPages: {
        type: Boolean,
        default: false
      }
    },
    components: {
      'app-input-select': InputSelect
    },
    computed: {
      showOrderBy () {
        return this.orderByOptions.length > 0;
      },
      currentPage () {
        return this.pagination.currentPage;
      },
      itemsPerPage () {
        return this.pagination.perPage;
      },
      totalItems () {
        return this.pagination.totalCount;
      },
      totalPages () {
        return this.pagination.totalPages;
      },
      firstItem () {
        return (this.itemsPerPage * (this.currentPage - 1)) + 1;
      },
      lastItem () {
        const lastRecord = this.itemsPerPage * this.currentPage;
        return lastRecord > this.totalItems? this.totalItems : lastRecord;
      },
      orderBy () {
        return this.pagination.order;
      },
      sortOrder () {
        return this.pagination.sort;
      },
      orderByOptionsArray () {
        return this.orderByOptions.map(option => {
          return { label: option.label, value: option.value }
        });
      }
    },
    methods: {
      onPaginationChange (type, value) {
        this.$emit('onPaginationChange', {type, value});
      }
    },
  }
</script>